import type { RegistrationStep } from '../../../components/RegistrationStepper/RegistrationStepper';

/**
 * Introduced registration has no email OTP step (removed at the client's request): the emailed
 * link proves the email, and Azure B2C verifies it again when the investor sets a password.
 */
export const INTRODUCED_STEPS: RegistrationStep[] = [
  { num: 1, label: 'Interest', icon: 'bi-globe2' },
  { num: 2, label: 'Consent', icon: 'bi-shield-check' },
  { num: 3, label: 'Personal', icon: 'bi-person' },
  { num: 4, label: 'Details', icon: 'bi-person-badge' }
];

/**
 * Every step after the start page carries the emailed link's token as ?ref=, and the API checks it
 * against the session: the session code in the path is short and guessable, the token is not.
 */
export const withRef = (path: string, ref: string) => `${path}?ref=${encodeURIComponent(ref)}`;
